import Immutable from 'seamless-immutable'

import * as actions from './actions'
import * as sendmailActions from '../sendmail/actions'

const initialState = Immutable.from({
  financeData: {
    isFetching: false,
    error: false,
    externalId: null,
    data: {},
  },
  financeWidgetSettings: {
    externalId: null,
    cash: 0,
    months: 0,
    salvageValue: 0,
    monthlyPrice: 0,
    totalCost: 0,
    effectiveRate: 0,
  },
  adReplyOptions: {
    finance: false,
    tradeIn: {
      checked: false,
      regNumber: '',
      mileage: '',
    },
  },
  carAuction: {
    form: {
      licensePlate: {
        value: '',
        errorText: '',
        status: '',
      },
      odometer: {
        value: '',
        errorText: '',
        status: '',
      },
      senderPhone: {
        value: '',
        errorText: '',
        status: '',
      },
      emailAddress: {
        value: '',
        errorText: '',
        status: '',
      },
      knownIssues: {
        value: '',
        errorText: '',
        status: '',
      },
      wantedDate: {
        value: '',
        errorText: '',
        status: '',
      },
      firstName: {
        value: '',
        errorText: '',
        status: '',
      },
      lastName: {
        value: '',
        errorText: '',
        status: '',
      },
      zipCode: {
        value: '',
        errorText: '',
        status: '',
      },
    },
    isSubmitted: false,
    isFetching: false,
    error: false,
    apiResponse: {
      displayStatus: 'warning',
      headline: 'Ånej!',
      body: 'Något blev fel. Försök igen.',
    },
  },
})

const motor = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case sendmailActions.HAS_MESSAGE_BEEN_SENT:
      if (!error && payload === true) {
        return state.set('adReplyOptions', initialState.adReplyOptions)
      }
      return state
    case actions.AD_REPLY_OPTIONS_TRADE_IN:
      return state.setIn(['adReplyOptions', 'tradeIn'], {
        checked: payload.checked || false,
        regNumber: payload.regNumber || '',
        mileage: payload.mileage || '',
      })
    case actions.SAVE_WIDGET_SETTINGS:
      return state.set('financeWidgetSettings', {
        externalId: payload.externalId,
        cash: payload.cash,
        months: payload.months,
        salvageValue: payload.salvageValue,
        monthlyPrice: payload.monthlyPrice,
        totalCost: payload.totalCost,
        effectiveRate: payload.effectiveRate,
        price: payload.price,
      })
    case actions.REQUEST_FINANCE_DATA:
      return state.setIn(['financeData', 'isFetching'], true)
    case actions.RECEIVE_FINANCE_DATA:
      if (error) {
        return state.set('financeData', {
          ...initialState.financeData,
          error: payload,
        })
      }
      return state.set('financeData', {
        ...initialState.financeData,
        externalId: payload.externalId,
        data: payload.data,
      })
    case actions.AD_REPLY_OPTION_FINANCE:
      return state.setIn(['adReplyOptions', 'finance'], payload)
    case actions.CAR_AUCTION_UPDATE_FORM_FIELD:
      return state.setIn(['carAuction', 'form', `${payload.name}`], {
        ...state.carAuction.form[payload.name],
        ...payload.data,
      })
    case actions.CAR_AUCTION_API_AUTHENTICATE:
      return state.merge({
        carAuction: {
          ...state.carAuction,
          isSubmitted: false,
          isFetching: false,
        },
      })
    case actions.CAR_AUCTION_API_AUTHENTICATE_SUCCESS:
      return state.merge({
        carAuction: {
          ...state.carAuction,
          isSubmitted: false,
          isFetching: false,
          error: false,
          apiResponse: {
            ...payload.data,
          },
        },
      })
    case actions.CAR_AUCTION_API_AUTHENTICATE_FAIL:
      return state.merge({
        carAuction: {
          ...state.carAuction,
          isSubmitted: true,
          isFetching: false,
          error: true,
          apiResponse: {
            ...payload.data,
          },
        },
      })
    case actions.CAR_AUCTION_API_POST_FORM_DATA:
      return state.merge({
        carAuction: {
          ...state.carAuction,
          isSubmitted: true,
          isFetching: true,
        },
      })
    case actions.CAR_AUCTION_REOPEN_FORM:
      return state.merge({
        carAuction: {
          ...state.carAuction,
          isSubmitted: false,
          isFetching: false,
          error: false,
          apiResponse: {},
        },
      })
    case actions.CAR_AUCTION_API_RESPONSE_SUCCESS:
      return state.merge({
        carAuction: {
          ...state.carAuction,
          isSubmitted: true,
          isFetching: false,
          error: false,
          apiResponse: {
            ...payload.data,
          },
        },
      })
    case actions.CAR_AUCTION_API_RESPONSE_FAIL:
      return state.merge({
        carAuction: {
          ...state.carAuction,
          isSubmitted: true,
          isFetching: false,
          error: true,
          apiResponse: {
            ...payload.data,
          },
        },
      })
    case actions.CAR_AUCTION_RESET_FORM:
      return state.set('carAuction', {
        ...initialState.carAuction,
      })
    default:
      return state
  }
}

export default motor
